/* ACC_CB_Landingpage_16 — single-file build: shared bus, scroll, accordion, sticky bar,
   header/footer toggle, review slider, buy box (gallery + variant picker), final CTA sync. */
import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

/* ------------------------------- Shared bus ------------------------------- */
var acc16State = {
    variantId: null,
    price: null,
    compareAtPrice: null,
    available: true,
    title: '',
    image: null
};

function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme_money_format) {
        return Shopify.formatMoney(cents, window.theme_money_format);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
    }
}

function setVariant(detail) {
    acc16State = Object.assign({}, acc16State, detail);
    document.dispatchEvent(new CustomEvent('acc16:variant-change', { detail: acc16State }));
}

window.ACC16 = {
    formatMoney: formatMoney,
    setVariant: setVariant,
    getState: function () { return acc16State; }
};

/* ------------------------------- Smooth scroll ------------------------------- */
document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* ------------------------------- Accordion (FAQ) ------------------------------- */
document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-acc16-accordion-trigger]');
    if (!trigger) return;
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId && document.getElementById(panelId);
    if (!panel) return;
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var item = trigger.closest('[data-acc16-accordion-item]');
    var accordion = trigger.closest('.acc16-12__accordion');

    if (!expanded && accordion) {
        accordion.querySelectorAll('[data-acc16-accordion-item]').forEach(function (otherItem) {
            if (otherItem === item) return;
            var otherTrigger = otherItem.querySelector('[data-acc16-accordion-trigger]');
            var otherPanelId = otherTrigger && otherTrigger.getAttribute('aria-controls');
            var otherPanel = otherPanelId && document.getElementById(otherPanelId);
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.hidden = true;
            otherItem.classList.remove('is-open');
        });
    }

    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
    if (item) item.classList.toggle('is-open', !expanded);
});

/* ------------------------------- Sticky buy bar ------------------------------- */
function initStickyBar() {
    var bar = document.querySelector('[data-acc16-sticky-bar]');
    var offer = document.getElementById('acc_cb_lp_16_offer');
    if (!bar || !offer || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                var offerPassed = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
                bar.classList.toggle('is-visible', offerPassed);
            });
        },
        { threshold: 0, rootMargin: '0px' }
    );
    observer.observe(offer);
}

/* ------------------------------- Header/footer toggle ------------------------------- */
function applyHeaderFooterVisibility() {
    var flag = document.querySelector('[data-acc16-hide-header-footer]');
    if (!flag || flag.getAttribute('data-acc16-hide-header-footer') !== 'true') return;
    var selectors = '[id*="group-header"], [id*="header-group"], [id*="group-footer"], [id*="footer-group"]';
    document.querySelectorAll(selectors).forEach(function (el) {
        el.style.display = 'none';
    });
}

/* ------------------------------- Section 08: review slider (<1014px only) ------------------------------- */
function initReviewSlider() {
    var SLIDER_QUERY = '(max-width: 1013px)';
    var swiperInstance = null;

    function getContainer() {
        return document.querySelector('[data-acc16-review-slider]');
    }

    function initSwiper() {
        var container = getContainer();
        if (!container || swiperInstance) return;
        swiperInstance = new Swiper(container, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 24,
            centeredSlides: false,
            grabCursor: true,
            watchOverflow: true,
            navigation: false,
            pagination: false,
        });
        swiperInstance.update();
        container.dataset.swiperInitialized = 'true';
    }

    function observeActiveVideo(container) {
        const wrapper = container.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        const update = () => {
            container.querySelectorAll('video').forEach((video) => {
                video.pause();
                video.currentTime = 0;
            });

            const activeVideo = container.querySelector('.swiper-slide-active video');
            if (activeVideo) {
                activeVideo.muted = true;
                activeVideo.playsInline = true;
                activeVideo.play().catch(() => {});
            }
        };

        update();

        new MutationObserver(update).observe(wrapper, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function destroySwiper() {
        var container = getContainer();
        if (!swiperInstance) return;
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        if (container) delete container.dataset.swiperInitialized;
    }

    function handleViewportChange(mql) {
        if (mql.matches) initSwiper();
        else destroySwiper();
    }

    var mql = window.matchMedia(SLIDER_QUERY);
    handleViewportChange(mql);
    observeActiveVideo(document.querySelector('.acc16-10__main-wrap'));
    var onChange = function () { handleViewportChange(mql); };
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onChange);
    else if (typeof mql.addListener === 'function') mql.addListener(onChange);
    window.addEventListener('orientationchange', onChange);
}

/* ------------------------------- Section 10: buy box (gallery + variant picker) ------------------------------- */
function renderTemplate(tpl, map) {
    if (!tpl) return '';
    var out = tpl;
    Object.keys(map).forEach(function (key) {
        out = out.split('[[' + key + ']]').join(map[key]);
    });
    return out;
}

function toCents(raw) {
    var n = parseInt(raw, 10);
    return isNaN(n) ? 0 : n;
}

function initGallery(root) {
    var mainEl = root.querySelector('[data-acc16-main-swiper]');
    if (!mainEl) return null;

    var thumbsEl = root.querySelector('[data-acc16-thumbs-swiper]');
    var slideCount = mainEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    var thumbCount = thumbsEl ? thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length : 0;

    var thumbsSwiper = null;
    if (thumbsEl && thumbCount > 0) {
        thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 8,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            breakpoints: {
                990: {
                    slidesPerView: Math.min(6, thumbCount),
                    spaceBetween: 8
                }
            }
        });
    }

    var prevBtn = root.querySelector('[data-acc16-gallery-prev]');
    var nextBtn = root.querySelector('[data-acc16-gallery-next]');
    var hasDesktopNav = window.matchMedia('(min-width: 990px)').matches && prevBtn && nextBtn;

    var mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        keyboard: { enabled: true },
        navigation: hasDesktopNav ? { nextEl: nextBtn, prevEl: prevBtn } : false,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
        watchOverflow: true
    });

    mainSwiper.update();

    if (slideCount <= 1 || !hasDesktopNav) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
    }

    return mainSwiper;
}

// Swiper's `.slides` collection is used (not a stale querySelectorAll snapshot) because
// loop mode re-parents/duplicates slide elements as the user swipes.
function slideToMedia(mainSwiper, imageId) {
    if (!mainSwiper || !imageId || !mainSwiper.slides) return;
    var slides = mainSwiper.slides;
    for (var i = 0; i < slides.length; i++) {
        var slideImageId = slides[i].getAttribute ? slides[i].getAttribute('data-image-id') : null;
        if (slideImageId && slideImageId === String(imageId)) {
            mainSwiper.slideTo(i, 300, false);
            return;
        }
    }
}

function readVariantData(btn) {
    var ds = btn.dataset;
    var priceCents = toCents(ds.variantPrice);
    var compareCents = ds.variantCompareAt ? toCents(ds.variantCompareAt) : 0;
    return {
        variantId: ds.variantId,
        title: ds.variantTitle || '',
        priceCents: priceCents,
        compareCents: compareCents,
        hasCompare: compareCents > priceCents,
        available: ds.variantAvailable === 'true',
        imageId: ds.variantImageId || '',
        imageUrl: ds.variantImage || ''
    };
}

function updateSwatchesActiveState(root, activeBtn) {
    root.querySelectorAll('[data-acc16-swatch]').forEach(function (b) {
        var isActive = b === activeBtn;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
}

function updatePriceBlock(root, data) {
    var saleEl = root.querySelector('[data-acc16-sale-price]');
    var compareWrap = root.querySelector('[data-acc16-compare-wrap]');
    var compareEl = root.querySelector('[data-acc16-compare-price]');
    var savingsEl = root.querySelector('[data-acc16-savings]');

    if (saleEl) saleEl.textContent = formatMoney(data.priceCents);
    if (compareWrap) compareWrap.hidden = !data.hasCompare;
    if (compareEl) compareEl.textContent = data.hasCompare ? formatMoney(data.compareCents) : '';

    if (savingsEl) {
        if (data.hasCompare) {
            var tpl = root.getAttribute('data-savings-template') || 'Sommer-Sale — Du sparst [[savings]]';
            savingsEl.textContent = renderTemplate(tpl, { savings: formatMoney(data.compareCents - data.priceCents) });
            savingsEl.hidden = false;
        } else {
            savingsEl.hidden = true;
        }
    }
}

function updatePromoBanner(root, data) {
    var promo = root.querySelector('[data-acc16-promo-text]');
    if (!promo) return;
    var tpl = root.getAttribute('data-promo-template') || 'Sommer-Sale: [[price]] statt [[compare_at_price]]. Solange der Vorrat reicht.';
    promo.textContent = renderTemplate(tpl, {
        price: formatMoney(data.priceCents),
        compare_at_price: formatMoney(data.hasCompare ? data.compareCents : data.priceCents)
    });
}

function updateCta(root, data) {
    var cta = root.querySelector('[data-acc16-cta]');
    if (!cta || !data.variantId) return;
    var routesRoot = root.getAttribute('data-routes-root') || document.querySelector('[data-routes-root]')?.getAttribute('data-routes-root') || '/';
    cta.setAttribute('href', routesRoot + 'cart/' + data.variantId + ':1?checkout');
    if (data.available) {
        cta.removeAttribute('aria-disabled');
        cta.classList.remove('is-disabled');
    } else {
        cta.setAttribute('aria-disabled', 'true');
        cta.classList.add('is-disabled');
    }
}

function updateFarbeLabel(root, data) {
    var label = root.querySelector('[data-acc16-farbe-label]');
    if (label) label.textContent = (data.title || '').toUpperCase();
}

function broadcastVariant(data) {
    setVariant({
        variantId: data.variantId,
        price: data.priceCents,
        compareAtPrice: data.hasCompare ? data.compareCents : null,
        available: data.available,
        title: data.title,
        image: data.imageUrl
    });
}

function applyVariant(root, btn, mainSwiper) {
    var data = readVariantData(btn);
    updateSwatchesActiveState(root, btn);
    updateFarbeLabel(root, data);
    updatePriceBlock(root, data);
    updatePromoBanner(root, data);
    updateCta(root, data);
    slideToMedia(mainSwiper, data.imageId);
    broadcastVariant(data);
}

function initBuyBox(root) {
    var mainSwiper = initGallery(root);

    root.querySelectorAll('[data-acc16-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            applyVariant(root, btn, mainSwiper);
        });
    });

    var activeBtn = root.querySelector('[data-acc16-swatch].is-active') || root.querySelector('[data-acc16-swatch]');
    if (activeBtn) {
        var initialData = readVariantData(activeBtn);
        slideToMedia(mainSwiper, initialData.imageId);
        broadcastVariant(initialData);
    }
}

/* ------------------------------- Section 02 hero + Section 13 final CTA/sticky: live price sync ------------------------------- */
function getCartBase() {
    var root = document.querySelector('[data-cart-base]');
    return root ? root.getAttribute('data-cart-base') : '/cart/';
}

document.addEventListener('acc16:variant-change', function (e) {
    var detail = (e && e.detail) || {};

    if (typeof detail.price === 'number') {
        var priceText = formatMoney(detail.price);
        document
            .querySelectorAll('[data-acc16-hero-price], [data-acc16-final-price], [data-acc16-final-cta-price], [data-acc16-sticky-price], [data-acc16-07-price]')
            .forEach(function (el) { el.textContent = priceText; });
    }

    if (detail.title) {
        document.querySelectorAll('[data-acc16-sticky-title]').forEach(function (el) { el.textContent = detail.title; });
    }

    if (detail.variantId) {
        var href = getCartBase() + detail.variantId + ':1?checkout';
        document.querySelectorAll('[data-acc16-final-cta], [data-acc16-sticky-cta]').forEach(function (a) {
            a.setAttribute('href', href);
        });
    }

    var available = detail.available !== false;
    document.querySelectorAll('[data-acc16-final-cta], [data-acc16-sticky-cta]').forEach(function (a) {
        if (available) a.removeAttribute('aria-disabled');
        else a.setAttribute('aria-disabled', 'true');
    });
});

/* ------------------------------------- Init ------------------------------------- */
function setup() {
    initStickyBar();
    applyHeaderFooterVisibility();
    initReviewSlider();
    document.querySelectorAll('.acc16-10').forEach(initBuyBox);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
} else {
    setup();
}
